import { BsFillShieldLockFill, BsTelephoneFill } from "react-icons/bs";
import { CgSpinner } from "react-icons/cg";
import { IoReloadOutline } from "react-icons/io5";
import React, { useState, useEffect } from 'react';
import OtpInput from "otp-input-react";
import { useRecoilState } from 'recoil';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { auth } from "./firebase.config";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { toast, Toaster } from "react-hot-toast";
import { user_data, user_login_state, user_role, w_labels, langs, chosen_lang, redir, surveys, _online, _surveystatus, _enablesurvey } from '../RecoilState';
import Text from '../components/Text'
import axios from 'axios';
import { Spin, message, Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

// FIREBASE OTP


const GOOGLEOTP = () => {
  const [otp, setOtp] = useState("");
  const [ph, setPh] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [user, setUser] = useState(null);
  const [isonline, setIsonline] = useRecoilState(_online);
  const [labels, setLabels] = useRecoilState(w_labels);
  const [justphonenumber, setJustPhonenumber] = useState("");
  const [timeLeft, setTimeLeft] = useState(30);
  const [isRunning, setIsRunning] = useState(false);
  const [firebaseToken, setFirebasetoken] = useState("");
  const [userfound, setUserfound] = useState(true)
  const [pageRefresh, setPagerefresh] = useState(false)
  const [redirect, setRedirect] = useRecoilState(redir);
  const [userdata, setUserdata] = useRecoilState(user_data);
  const [loginstate, setLoginstate] = useRecoilState(user_login_state);
  const [userrole, setUserrole] = useRecoilState(user_role);
  const [buttonclicked, setButtonclicked] = useState(false);
  const [firebaseerror, setFirebaseerror] = useState("")
  const [usernotfound, setUsernotfound] = useState(false)
  const [bypass, setBypass] = useState(false)
  const [bypassotp, setBypassotp] = useState(false)
  const [enablesurvey, setEnablesurvey] = useRecoilState(_enablesurvey)


  // const startTimer = () => {
  //   setIsRunning(true);
  // };

  console.log("Google OTP")

  useEffect(() => {
    if (isRunning && timeLeft > 0) {
      const interval = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [isRunning, timeLeft]);

  // useEffect(() => { console.log(surveystatus) }, [surveystatus])

  useEffect(() => {
    if (timeLeft === 0) {
      setIsRunning(false);
      setTimeLeft(30);
      setBypassotp(true);
    }
  }, [timeLeft])

  useEffect(() => {
    // console.log(userdata)
    // console.log(userrole)
  }, [userdata]);

  function onCaptchVerify() {
    console.log("onCaptchVerifyUser")
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            // console.log(response)
            // onSignup();
          },
          "expired-callback": () => { },
        },
        auth
      );
    }
  }

  function onSignup() {
    console.log("onSignup")
    setLoading(true);
    onCaptchVerify();

    const appVerifier = window.recaptchaVerifier;

    const formatPh = "+" + ph;

    signInWithPhoneNumber(auth, formatPh, appVerifier)
      .then((confirmationResult) => {
        console.log(confirmationResult)
        window.confirmationResult = confirmationResult;
        setLoading(false);
        setShowOTP(true);
        // toast.success("OTP sent successfully!");
        setIsRunning(true);
        setButtonclicked(false);

      })
      .catch((error) => {
        console.log(error);
        setFirebaseerror("Please refesh if OTP / Capcha verification is not shown in next 30 seconds");
        setBypass(true)
        setLoading(false);
        setIsRunning(false);
        setTimeLeft(30);
        setPagerefresh(true);
        setButtonclicked(false);

      });
  }

  function onRetry() {
    console.log("onRetry");
    onSignup();

    // setIsRunning(true);
    // setLoading(true);
    // onCaptchVerify();

    // const appVerifier = window.recaptchaVerifier;

    // const formatPh = "+" + ph;

    // signInWithPhoneNumber(auth, formatPh, appVerifier)
    //   .then((confirmationResult) => {
    //     window.confirmationResult = confirmationResult;
    //     setLoading(false);
    //     setShowOTP(true);
    //     // toast.success("OTP sent successfully!");
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     setFirebaseerror("Attempts or Captcha Related Error - Firebase OTP");
    //     setLoading(false);
    //     setPagerefresh(true);
    //   });
  }

  function onOTPVerify() {
    console.log("onOTPVerify")
    setLoading(true);
    window.confirmationResult
      .confirm(otp)
      .then(async (res) => {
        setFirebasetoken(res._tokenResponse.idToken);
        middlewareFirebaseauth(res._tokenResponse.idToken)
        setUser(res.user);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setFirebaseerror("OTP Related Error - Firebase OTP");
        setLoading(false);
      });
  }

  function checkRegistration() {
    console.log("checkRegistration")
    setButtonclicked(true);
    setBypass(true)
    delete axios.defaults.headers.common["Authorization"];

    const justnumber = ph.toString().slice(-10);
    // console.log(justnumber)
    setJustPhonenumber(justnumber);

    const data = {
      username: justnumber
    };

    axios.post('auth/username', data)
      .then(response => {
        const valid = response.data.data.isRegistered;
        // setUserfound(valid)
        // toast.success("OTP sent successfully!");
        // console.log(response.data)
        if (valid === true) {
          onSignup()
        }
        else {
          setButtonclicked(false);
          setUsernotfound(true);
          // toast.error("User not found");
        }

        // else {
        //   console.log("user not found")
        // }
        // console.log(response);
      })
      .catch(error => {
        console.log(error);
        // setUserfound(false);
        setButtonclicked(false);
        toast.error("Server Error");
      });
  }

  function otpbypass() {
    console.log("middlewareFirebaseauth")
    setLoading(true)
    setBypass(false)
    setBypassotp(false)
    const data = {
      token: 123456,
      username: justphonenumber
    };
    axios.post('auth/firebase', data)
      .then(response => {
        // console.log(response.data.data);
        localStorage.setItem('respondent_mpu_token', response.data.data);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('respondent_mpu_token');
        getProfiledata();
      })
      .catch(error => {
        console.log(error);
        setBypass(true);
        setBypassotp(true);
      });
  }

  function middlewareFirebaseauth(fbidtoken) {
    console.log("middlewareFirebaseauth")
    const data = {
      token: fbidtoken,
      username: justphonenumber
    };

    axios.post('auth/firebase', data)
      .then(response => {
        // console.log(response.data.data);
        localStorage.setItem('respondent_mpu_token', response.data.data);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('respondent_mpu_token');
        getProfiledata();
      })
      .catch(error => {
        console.log(error);
      });
  }

  function getProfiledata() {
    console.log('getProfiledata')
    axios.get('respondent/profile')
      .then(response => {
        setUserdata(response.data.data);
        setUserrole(response.data.data.type);
        // dob(response.data.data.date_of_birth);
        setRedirect("welcome")
        const complete = response.data.data.enabled_for_survey;
        console.log(complete)
        if (complete === false) { setEnablesurvey(false) }
        // console.log("respondent profile");
        console.log(response.data.data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  function Usernotregistered() {

    function retrybutton() {
      // console.log("clicked")
      setPh("")
      setUsernotfound(false)
    }

    return (
      <>
        <div className='mt-[100px] mb-[20px]'>
          <Text style={"sub-heading text-bold text-center"} value={labels[47]} />
          <Text style={"sub-heading text-center"} value={labels[59]} />
        </div>
        <div className="flex justify-center mt-10">
          <Button type="secondary" shape="round" size="large" onClick={() => retrybutton()}>
            <div className="flex justify-center gap-x-4 items-center">
              {/* <Text style={"text"} value={labels[58]} /> */}
              <div className="mx-[5px]"> </div>
              <IoReloadOutline />
              <div className="mx-[5px]"> </div>
            </div>
          </Button>
        </div>
      </>
    )
  }

  return (
    <div className="header-accomodate">
      <div className="spacer">
        <div className="mb-5">
          <Text style={"large-gradient-heading text-center"} value={labels[8]} />
        </div>

        {usernotfound ?
          <Usernotregistered />
          :
          // firebase OTP validation UI
          <>
            <section className="flex items-center justify-center mb-[30px]">
              <div>
                <Toaster toastOptions={{ duration: 1000 }} />
                <div id="recaptcha-container"></div>
                {
                  user ?
                    (
                      // login success
                      <h2 className="text-center font-medium text-l mt-5">
                        Login Success. Loading
                        <Spin />
                      </h2>
                    )
                    :
                    (
                      <div className="w-full flex flex-col gap-4 rounded-lg p-4">
                        {
                          showOTP ?
                            (
                              /* input otp */
                              <>
                                <h2 className="font-bold text-xl text-left">+{ph}</h2>
                                <div className="mb-2">
                                  <Text style={"text"} value={labels[45]} />
                                </div>
                                <OtpInput
                                  value={otp}
                                  onChange={setOtp}
                                  OTPLength={6}
                                  otpType="number"
                                  disabled={false}
                                  autoFocus
                                  className="opt-container"
                                ></OtpInput>
                                <button
                                  onClick={onOTPVerify}
                                  className="border-[1px] border-emerald-600 w-full flex gap-1 items-center justify-center py-2.5  rounded"
                                >
                                  {loading && (
                                    <CgSpinner size={20} className="mt-1 animate-spin" />
                                  )}
                                  <span>
                                    <Text style={"text"} value={labels[4]} />
                                  </span>
                                </button>

                                <div className="mb-2 mt-[50px]">
                                  <Text style={"text"} value={labels[5]} />
                                </div>


                                {/* resend */}
                                {isRunning ? <h2>Resend in {timeLeft} seconds</h2>
                                  :
                                  (
                                    <>
                                      <button
                                        onClick={onRetry}
                                        className="border-[1px] border-emerald-600 w-full flex gap-1 items-center justify-center py-2.5  rounded"
                                      >
                                        {loading && (
                                          <CgSpinner size={20} className="mt-1 animate-spin" />
                                        )}
                                        <span>
                                          <Text style={"text"} value={labels[6]} />
                                        </span>
                                      </button>
                                    </>
                                  )
                                }

                              </>
                            )
                            :
                            (

                              <>
                                {/* verify phone number */}
                                <>
                                  <label
                                    htmlFor=""
                                    className="font-bold text-xl mt-[30px]"
                                  >
                                    <div className='mb-[20px]'>
                                      <Text style={"text sub-heading"} value={labels[42]} />
                                    </div>
                                  </label>
                                  <PhoneInput country={"in"} onlyCountries={['in']} value={ph} onChange={setPh} />
                                  {
                                    buttonclicked ?
                                      (
                                        <div className="mt-5 mx-auto">
                                          <Spin />
                                        </div>
                                      )
                                      :
                                      (
                                        <button
                                          onClick={checkRegistration}
                                          className="border-[1px] border-emerald-600 w-full flex gap-1 items-center justify-center py-2.5  rounded"
                                        >
                                          {loading && (
                                            <CgSpinner size={20} className="mt-1 animate-spin" />
                                          )}
                                          <span>
                                            <Text style={"text"} value={labels[43]} />
                                          </span>
                                        </button>
                                      )
                                  }
                                </>
                              </>
                            )
                        }
                      </div>
                    )
                }
              </div>
            </section>
            <div className="mt-[30px]">
              {/* page refresh message */}
              {
                pageRefresh ?
                  (
                    // <>
                    //   {/* <h2 className="text-center">Please refresh this page</h2> */}
                    //   <Text style={"text-heading text-center"} value={labels[46]} />
                    // </>
                    null
                  )
                  :
                  null
              }
            </div>
          </>
        }

        <div className="mt-6">
          {/* <p>------------</p> */}
          {/* <p>for testing puropses only</p> */}
          <p>{firebaseerror}</p>
          <>
            {
              bypass ?
                <button onClick={otpbypass} className="border-[1px] border-emerald-600 flex gap-1 items-center justify-center p-2  rounded">
                  <p>Bypass</p>
                </button>
                : null
            }
          </>
          <>
            {
              bypassotp ?
                <button onClick={otpbypass} className="border-[1px] border-emerald-600 flex gap-1 items-center flex-row align-center p-2  rounded">
                  <p>Bypass</p>
                </button>
                : null
            }
          </>
        </div>
      </div>
    </div>
  );
};

export default GOOGLEOTP;
